import { ReqParams } from "@/types";
import axiosInstance from "./axiosInstance";

export default class CustomerService {
    static async getFeedbackList(params: ReqParams = {}) {
        const response = await axiosInstance.get("/customer/feedback-invitations", { params });
        return response.data;
    }
    static async getFeedbackDetail(id: number) {
        const response = await axiosInstance.get(`/customer/feedback-details/${id}`);
        return response.data;
    }

    static async getTicketList(params: ReqParams = {}) {
        const response = await axiosInstance.get("/customer/ticket-list", { params });
        return response.data;
    }
    static async getTicketDetails(params: ReqParams = {}) {
        const response = await axiosInstance.get(`/customer/ticket-details/${params?.id}`);
        return response.data;
    }

    static async submitFeedback(data: ReqParams = {}, token: string) {
        const response = await axiosInstance.post(`/customer/feedback?token=${token}`, data);
        return response.data;
    }

    static async submitTicket(data: ReqParams = {},ticketId: number) {
        const response = await axiosInstance.post(`/customer/ticket/${ticketId}/send-message`, data, {
            skipGlobalLoader: true,
        });
        return response.data;
    }

    static async SalesTalkWithAiChat(data: ReqParams = {}) {
        const response = await axiosInstance.post(`customer/ai-chat`, data, {
            skipGlobalLoader: true,
        });
        return response.data;
    }

    static async genearteSalesRequest(data: ReqParams = {}) {
        const response = await axiosInstance.post(`customer/ai-chat/confirm-ticket`, data, {
            skipGlobalLoader: true,
        });
        return response.data;
    }
}
